import { computed, nextTick, unref } from 'vue-demi';
import { useRoute, useRouter } from 'vue-router';

function useRouteHash(defaultValue, {
  mode = "replace",
  route = useRoute(),
  router = useRouter()
} = {}) {
  return computed({
    get() {
      var _a;
      return (_a = route.hash) != null ? _a : defaultValue;
    },
    set(v) {
      nextTick(() => {
        router[unref(mode)]({ hash: v });
      });
    }
  });
}

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function useRouteQuery(name, defaultValue, {
  mode = "replace",
  route = useRoute(),
  router = useRouter()
} = {}) {
  return computed({
    get() {
      const data = route.query[name];
      if (data == null)
        return defaultValue != null ? defaultValue : null;
      if (Array.isArray(data))
        return data.filter(Boolean);
      return data;
    },
    set(v) {
      nextTick(() => {
        router[unref(mode)]({ query: __spreadProps(__spreadValues({}, route.query), { [name]: v === defaultValue || v === null ? void 0 : v }) });
      });
    }
  });
}

export { useRouteHash, useRouteQuery };
